import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'game-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/navbar/navbar.component.ts